import { useEffect, useState } from "react";
import { TrendingUp } from "lucide-react";
import { Bar, CartesianGrid, ComposedChart, Legend, Line, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { api } from "../lib/api";

const COLORS = ["#F04E23", "#0EA5E9", "#10B981", "#A855F7", "#F59E0B", "#EC4899", "#14B8A6", "#64748B"];
const label = (m) => new Date(m + "-01T00:00:00").toLocaleDateString("id-ID", { month: "short", year: "2-digit" });

export function PppTrendChart({ routerId }) {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/ppp/evaluasi/tren", { params: { months: 6, router_id: routerId === "all" ? "" : routerId } }).then((r) => setData(r.data)).catch(() => setData([])); }, [routerId]);
  if (!data) return null;
  const routers = [...new Set(data.flatMap((d) => Object.keys(d.per_router || {})))].slice(0, 8);
  const rows = data.map((d) => ({ bulan: label(d.month), "Tingkat %": d.rate, Perpanjang: d.perpanjang, Tidak: d.tidak, ...d.per_router }));
  const showPerRouter = routerId === "all" && routers.length > 1;
  return (
    <div className="rounded-xl border border-border bg-card p-3" data-testid="ppp-trend-chart">
      <div className="text-xs font-semibold flex items-center gap-1.5 mb-1"><TrendingUp className="w-3.5 h-3.5 text-emerald-500" /> Tren Tingkat Perpanjangan 6 Bulan {showPerRouter && <span className="text-muted-foreground font-normal">· garis = % per cabang</span>}</div>
      <div className="h-56">
        <ResponsiveContainer width="100%" height="100%">
          <ComposedChart data={rows} margin={{ top: 8, right: 8, left: -16, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="currentColor" opacity={0.1} />
            <XAxis dataKey="bulan" tick={{ fontSize: 11 }} />
            <YAxis yAxisId="n" tick={{ fontSize: 11 }} allowDecimals={false} />
            <YAxis yAxisId="pct" orientation="right" domain={[0, 100]} tick={{ fontSize: 11 }} unit="%" />
            <Tooltip contentStyle={{ fontSize: 12, borderRadius: 8 }} />
            <Legend wrapperStyle={{ fontSize: 11 }} />
            <Bar yAxisId="n" dataKey="Perpanjang" fill="#10B981" radius={[4, 4, 0, 0]} />
            <Bar yAxisId="n" dataKey="Tidak" fill="#F43F5E" radius={[4, 4, 0, 0]} />
            {showPerRouter
              ? routers.map((r, i) => <Line key={r} yAxisId="pct" type="monotone" dataKey={r} stroke={COLORS[i % COLORS.length]} strokeWidth={2} dot={{ r: 3 }} connectNulls />)
              : <Line yAxisId="pct" type="monotone" dataKey="Tingkat %" stroke="#F04E23" strokeWidth={2.5} dot={{ r: 4 }} />}
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
